"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useNotifications;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useNotifications() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var notifications = _ref.notifications;
    return notifications;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VOb3RpZmljYXRpb25zIiwidXNlU2VsZWN0b3IiLCJub3RpZmljYXRpb25zIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlTm90aWZpY2F0aW9ucy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5pbXBvcnQgTm90aWZpY2F0aW9uIGZyb20gJy4uL3R5cGVzL05vdGlmaWNhdGlvbic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZU5vdGlmaWNhdGlvbnMoKTogW05vdGlmaWNhdGlvbltdXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgbm90aWZpY2F0aW9ucyB9KSA9PiBub3RpZmljYXRpb25zKV07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFHZSxTQUFTQSxnQkFBVCxHQUE4QztFQUMzRCxPQUFPLENBQUMsSUFBQUMsZ0NBQUEsRUFBWTtJQUFBLElBQUdDLGFBQUgsUUFBR0EsYUFBSDtJQUFBLE9BQXVCQSxhQUF2QjtFQUFBLENBQVosQ0FBRCxDQUFQO0FBQ0QifQ==